/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".checkbox-container[_ngcontent-%COMP%]{height:48px;padding:0 10px;border-radius:4px;background-color:#fff;background-size:cover;box-shadow:0 2px 4px rgba(0,0,0,.1);align-items:center;display:flex;justify-content:flex-end}"];
export { styles as styles };
